export default __webpack_public_path__ + "static/bs-2588ec35d1cbf6130dbbe4b68396cd23.svg";